import React, { useState, useContext, Fragment } from "react";
import { ListItem, ListItemText, Typography } from "@material-ui/core";
import { getMeter } from "../apis/elastic";
import { DesignContext } from "../context/design";
import { LangContext } from "../context/lang";

interface IMeterInfo {
  loadInfo: boolean;
  setloadInfo: Function;
  sg: any;
}

const MeterInfo = (props: IMeterInfo) => {
  const { loadInfo, setloadInfo, sg } = props;
  const [detail, setdetail] = useState<any>(undefined);
  const { map } = useContext(DesignContext);
  const { lang } = useContext(LangContext);

  const _clickInfo = (sg: any) => async () => {
    setloadInfo(true);
    const rs = await getMeter(sg._id);
    setloadInfo(false);
    map?.flyTo({
      center: [Number(rs.lat), Number(rs.lon)],
      zoom: 19.333333333,
    });
    const { lat, lon, ...properties } = rs;
    const hilightLayerName = "hilight-meter-search";
    const mapEvent: any = map;
    const geoJsonSource = {
      type: "FeatureCollection",
      features: [
        {
          type: "Feature",
          properties: properties,
          geometry: { type: "Point", coordinates: [lat, lon] },
        },
      ],
    };
    if (mapEvent?.getSource(hilightLayerName)) {
      mapEvent?.getSource(hilightLayerName).setData(geoJsonSource);
    } else {
      const hilightLayer: any = {
        id: hilightLayerName,
        type: "circle",
        source: {
          type: "geojson",
          data: geoJsonSource,
        },
        paint: {
          "circle-radius": 6,
          "circle-color": "rgba(0,0,0,0)",
          "circle-stroke-width": 2,
          "circle-stroke-color": "#ff0000",
        },
      };

      map?.addLayer(hilightLayer);
    }

    setdetail(rs);
  };
  return (
    <ListItem button key={sg._id} onClick={_clickInfo(sg)} disabled={loadInfo}>
      <ListItemText
        primary={sg.meter_no}
        secondary={
          detail ? (
            <Fragment>
              <Typography variant="body2" color="textSecondary" component="p">
                {`${sg.name} ${sg.sur_name} ${sg.house_no} ${sg.moo_village} ${sg.soi} ${sg.street} ${sg.sub_distinct} ${sg.district} ${sg.province} ${sg.postcode}`}
              </Typography>
              <Typography variant="body2" color="primary" component="p">
                {`MRU : ${detail.mru}`}
              </Typography>
              <Typography variant="body2" color="primary" component="p">
                {`${lang.data.department} : ${
                  lang.locale === "en"
                    ? detail.mea_district_name
                    : detail.mea_district_namt
                }`}
              </Typography>
            </Fragment>
          ) : (
            <Typography
              variant="body2"
              color="textSecondary"
              component="p"
            >{`${sg.name} ${sg.sur_name} ${sg.house_no} ${sg.moo_village} ${sg.soi} ${sg.street} ${sg.sub_distinct} ${sg.district} ${sg.province} ${sg.postcode}`}</Typography>
          )
        }
      />
    </ListItem>
  );
};

export default MeterInfo;
